import {
  COMPLETE_CHECKERS,
  COMPLETE_DATA_ENTRY,
} from '../WorkflowQueues/DataEntry/redux-objects/actionTypes';

//PREFIXES
const ACCOUNT = 'Account/';
const ADMIN = 'Admin/';
const ADVANCED_SEARCH = 'AdvancedSearch/';
const FARS_REPORT = 'farsReport/';
const REPORT_DRAFTS = 'ReportDrafts/';
const KEYWORDS = 'Keywords/';
const LOOKUP = 'Lookup/';
const NOTIFICATION = 'Notification/';
const NOTIFICATIONTEMPLATE = 'NotificationTemplate/';
const VENDOR = 'Vendor/';
const FORM_REVISION = 'FormRevision/';
const WORKFLOW = 'Workflow/';
const WORKFLOW_QUEUE = 'WorkflowQueue/';
const DATAENTRY = 'DataEntry/';
const Checkers = 'Checkers/';
const CRASH = 'Crash/';
const MERGE = 'Merge/';
const MAPPING = 'MAPPING/';
const DMV = 'DmvRequests/';
const DATATRANSCRIBER = 'DataTranscriber/';
const EXTRACT = 'Extract/';
const STANDARD_SUMMARY = 'StandardSummary/';
const POWERBI = 'PBI/';
const COMMENT = 'Comment/';
const REPORT = 'Report/';
const REPORT_CHAIN = 'ReportChain/';
export const GLOBAL_MERGE = 'GlobalMerge';

// DOCUMENT VIEWER
export const DOC_VIEWER_GET_ALL_DOCUMENTS = `${REPORT}GetAllDocuments`;

//LOOKUPS
export const POST_ALL_LOGS = 'Logging/ActivityLogs';
export const GET_ALL_TYPES_URL = `${LOOKUP}GetAllTypes`;
export const GET_ACTVIE_TYPES_URL = `${LOOKUP}GetActiveTypes`;

//ADMIN SETTINGS
export const GET_SETTING_URL = `${ADMIN}GetSettings`;
export const GET_COUNTY_CITIES = `${LOOKUP}GetCountyCities`;
export const GET_TYPES_BY_NAME = `${LOOKUP}GetTypesByName`;

// SETTINGS
export const GET_SETTINGS = `${ADMIN}GetSettings`;
export const SAVE_SETTING = `${ADMIN}SaveSetting`;

//FORM
export const SAVE_FORM_URL = `${ACCOUNT}SaveForm`;
export const CREATE_FORM_URL = `${ACCOUNT}CreateForm`;
export const HEART_BEAT = `${ACCOUNT}HeartBeat`;
export const GET_FORM_IO_FORMS_URL = `${ACCOUNT}GetFormIOForms`;
export const GET_FORM_REVISION_NAMES_URL = `${FORM_REVISION}GetFormNames`;
export const SEARCH_FORM_FIELD_CHANGES_URL = `${FORM_REVISION}SearchFieldChanges`;
export const FIND_FORMS_CONTAINING_FIELD_URL = `${FORM_REVISION}FindFormsContainingField`;
export const FIND_FORM_VALIDATIONS_FOR_FIELD_URL = `${FORM_REVISION}FindFormValidationsForField`;
export const RESTORE_FORM_REVISION_URL = `${FORM_REVISION}RestoreRevision`;
export const GET_PREVIOUS_REVISION_VALIDATION_URL = `${FORM_REVISION}GetPreviousRevisionValidation`;
export const DELETE_FARS_REPORT_URL = `${FARS_REPORT}FARSADeleteFarsReport`;
export const CREATE_FARS_REPORT_URL = `${FARS_REPORT}CreateFarsReport`;

//ADMIN
export const GET_USER_ADMIN_INFO = `${ADMIN}GetUserAdminInfo`;
export const GET_ROLE_ADMIN_INFO = `${ADMIN}GetRoleAdminInfo`;
export const UPDATE_ROLE = `${ADMIN}UpdateRole`;
export const ADD_OR_UPDATE_USER = `${ADMIN}AddOrUpdateUser`;

//REPORT CHAIN EDITOR
export const GET_REPORT_CHAIN_BY_OCK = `${REPORT_CHAIN}GetChainByOriginalCrashKey`;
export const SAVE_REPORT_CHAIN_CORRECTIONS = `${REPORT_CHAIN}SaveChainCorrections`;
export const MOVE_REPORT_TO_STEP = `${REPORT_CHAIN}MoveReportToStep`;
export const COMPLETE_REPORT_STEP = `${REPORT_CHAIN}CompleteReportStep`;

// MANAGEMENT QUEUE
export const SAVE_MANAGEMENT_LOCATION_DATA = `${DATAENTRY}SaveLocationDataFromManagement`;
export const VALIDATE_MANAGEMENT_LOCATION_DATA = `${DATAENTRY}ValidateLocationDataFromManagement`;

//LOGIN
export const LOGIN_URL = `${ACCOUNT}Login`;
export const GET_CID_FROM_AD_URL = `${ACCOUNT}GetCIDfromAD`;

//Investigator Form
export const INVESTIGATOR_FORM = 'neinvestigatorreportformlockedcopy';
export const GET_ALL_INVESTIGATOR_DRAFTS_URL = `${REPORT_DRAFTS}GetReportDrafts`;
export const GET_INVESTIGATOR_DRAFT_URL = `${REPORT_DRAFTS}GetReportDraft`;

//DataTranscriber Form
export const DATA_TRANSCRIBER_FORM = 'datatranscriberform';
export const DATA_TRANSCRIBER_FORM_ID = '5ecb865368430b9b29203dc2';

//Data Transcriber Validation Form
export const DATA_TRANSCRIBER_VALIDATION_FORM = 'datatranscribervalidationform';
export const DATA_TRANSCRIBER_VALIDATION_FORM_ID = '5ecb868c68430b9f5a203dc9';

//Data Entry Form
export const DATA_ENTRY_FORM = 'dataentryform';
export const DATA_ENTRY_FORM_ID = '5f2c491068430bdd4d2057d0';

//Driver Report Forms
export const DRIVER_FORM = 'driverreportform';
export const COMPLETE_DRIVER_REPORT = `${WORKFLOW}CompleteDriverReport`;

// Workflow Queues
export const GET_REPORTS_BY_QUEUE = `${WORKFLOW}GetReportsByQueueType`;
export const GET_REPORTS_BY_QUEUE_PAGED = `${WORKFLOW}GetReportsByQueueTypePaged`;
export const GET_REPORT_IMAGE_BY_WORKFLOW_ITEM_STEP = `${WORKFLOW}GetReportImageByWorkflowItemStep`;
export const FARS_FORM = 'nefatalityreportfinal';

//AdvancedSearch
export const EXECUTE_CASE_STUDY_SEARCH = `${ADVANCED_SEARCH}ExecuteCaseStudySearch`;
export const EXPORT_SERVERSIDE = `${ADVANCED_SEARCH}ExportDataServerside`;
export const EXPORT_SELECTED_RESULTS = `${ADVANCED_SEARCH}ExportDataAsExcel`;
export const SHARE_QUERY = `${ADVANCED_SEARCH}ShareQuery`;
export const GET_QUERY = `${ADVANCED_SEARCH}GetQuery`;

//Workflow
export const GET_WORKFLOW = `${WORKFLOW}GetAllWorkflows`;
export const SAVE_DATA_ENTRY = `${WORKFLOW}SaveDataEntry`;
export const GET_WORKFLOW_STEPS = `${WORKFLOW}GetWorkflowSteps`;
export const ASSIGN_WORKFLOW_ITEM_STEP = `${WORKFLOW}AssignWorkflowItemStep`;
export const GET_WORKFLOW_ITEM_STEP = `${WORKFLOW}GetWorkflowItemStep`;
export const UNASSIGN_WORKFLOW_ITEM_STEP = `${WORKFLOW}UnAssignWorkflowItemStep`;
export const GET_DATA_ENTRY_RECORDS = `${WORKFLOW}SearchPaperReportDataEntryQueue`;
export const GET_CHECKERS_WORKFLOW_ITEMS = `${WORKFLOW}SearchPaperReportCheckersQueue`;
export const UNASSIGN_WORKFLOW_ITEM_STEP_BY_ID = `${WORKFLOW}UnAssignWorkflowItemStepById`;
export const GET_KEYWORDS_BY_WORKFLOW_STEP = `${WORKFLOW}GetKeywordsByWorkflowStep`;
export const COMPLETE_WORKFLOW_STEP = `${WORKFLOW}CompleteWorkflowStep`;
export const GET_REPORTS_IN_MANAGEMENT_QUEUE = `${WORKFLOW}GetReportsInManagementQueue`;
export const GET_REPORTS_IN_MANAGEMENT_QUEUE_PAGED = `${WORKFLOW}GetReportsInManagementQueuePaged`;
export const GET_REPORTS_IN_MANAGEMENT_QUEUE_EXPORT = `${WORKFLOW}GetReportsInManagementQueueExport`;
export const GET_MANAGEMENT_ITEM_DATA = `${WORKFLOW}GetManagementReportData`;
export const SET_ACTIVE_STATUS = `${CRASH}SetActiveStatus`;
export const REMOVE_VIA_DOC_VIEWER = `${CRASH}RemoveViaDocViewer`;
export const UPDATE_DOCUMENT_ID_VIA_DOC_VIEWER = `${CRASH}UpdateDocumentIdViaDocViewer`;
export const UPDATE_DOCUMENT_SORT_ORDER_VIA_DOC_VIEWER = `${CRASH}UpdateDocumentSortOrderViaDocViewer`;
export const UPDATE_REPORT_TYPE_VIA_DOC_VIEWER = `${CRASH}\UpdateReportTypeViaDocViewer`;
export const SEARCH_PAPER_DATA_QUEUE = `${WORKFLOW}SearchPaperReportDataQueue`;
export const COMPLETE_PAPER_DATA_TRANSCRIBE = `${WORKFLOW}CompletePaperDataTranscribe`;
export const COMPLETE_PAPER_DATA_TRANSCRIBER_VALIDATION = `${WORKFLOW}CompletePaperDataTranscriberValidation`;
export const GET_ALL_DATA_TRANSCRIBER_VALIDATION = `${WORKFLOW}GetAllTranscriberValidationReports`;
export const GET_ALL_DATA_TRANSCRIBER = `${WORKFLOW}GetAllTranscriberReports`;
export const GET_PAPER_PDF = `${WORKFLOW}GetPaperPdf`;
export const SEARCH_CHECKERS_QUEUE = `${WORKFLOW}SearchCheckersQueue`;
export const SEARCH_CHECKERS_QUEUE_PAGED = `${WORKFLOW}SearchCheckersQueuePaged`;
export const SEND_TO_MANAGEMENT_QUEUE = `${WORKFLOW}SendToManagementQueue`;
export const SAVE_CHECKERS = `${WORKFLOW}SaveCheckers`;
export const SEARCH_DATA_ENTRY_QUEUE = `${WORKFLOW}SearchDataEntryQueue`;
export const SAVE_FORM_DATA_TO_CRASH_TABLES = `${WORKFLOW}SaveFormDataToCrashTables`;
export const GET_WORKFLOW_ITEM_STEP_BY_ID = `${WORKFLOW}GetWorkflowItemStepById`;
export const SAVE_MANAGEMENT_WORK = `${WORKFLOW}SaveManagementWork`;
export const SAVE_MANAGEMENT_SPLIT = `${WORKFLOW}SaveManagementSplit`;
export const GET_REPORT_BY_CRASH_KEY = `${WORKFLOW}GetReportByCrashKey`;
export const COMPLETE_HELD_DRIVER_REPORTS_KEYWORDS = `${WORKFLOW}CompleteKeywordsPaperDriverReport`;
export const MANAGEMENT_CRASH_KEY_SEARCH = `${WORKFLOW}ManagementCrashKeySearch`;

//Vendor
export const UPDATE_AGENCY = `${VENDOR}UpdateAgencyVendorBinding`;
export const GET_ALL_AGENCIES = `${VENDOR}AgencyList`;

//Keywords
export const SEARCH_KEYWORDS = `${KEYWORDS}SearchPaperReportKeywordQueue`;
export const SEARCH_KEYWORDS_PAGED = `${KEYWORDS}SearchPaperReportKeywordQueuePaged`;
export const GET_ALL_COUNTIES = `${KEYWORDS}GetCounties`;
export const GET_ALL_REPORT_TYPES = `${KEYWORDS}GetReportTypeInfo`;
export const SAVE_KEYWORDS = `${KEYWORDS}AddOrUpdateKeywords`;
export const GET_KEYWORDS = `${KEYWORDS}GetKeywords`;
export const SEARCH_KEYWORD_MATCHES = `${KEYWORDS}SearchKeywordMatches`;
export const DELETE_REPORT_FROM_KEYWORDS = `${KEYWORDS}DeleteReport`;
export const UNDELETE_REPORT_FROM_KEYWORDS = `${KEYWORDS}UnDeleteReport`;
export const GET_ADD_EDIT_KEYWORDS_DATA = `${KEYWORDS}GetAddEditKeywordsData`;
export const UPDATE_ADD_EDIT_KEYWORDS_DATA = `${KEYWORDS}UpdateAddEditKeywordsData`;

//Matching
export const MATCHING_QUEUE_SEARCH = `${WORKFLOW}SearchPartialMatchQueue`;
export const MATCHING_QUEUE_SEARCH_PAGED = `${WORKFLOW}SearchPartialMatchQueuePaged`;
export const ASSIGN_MERGE = `${WORKFLOW}AssignMerge`;
export const CANCEL_MERGE = `${WORKFLOW}CancelMerge`;
export const UNASSIGN_MERGE = `${WORKFLOW}UnAssignMerge`;
export const MARK_AS_NEW = `${WORKFLOW}MarkAsNew`;
export const DO_AUTO_MERGE = `${WORKFLOW}DoAutoMerge`;

//NotificationTemplate
export const LOAD_TEMPLATE_OPTIONS = `${NOTIFICATIONTEMPLATE}GetTemplateOptions`;
export const GET_TEMPLATES_BY_OPTION = `${NOTIFICATIONTEMPLATE}GetTemplatesByOption`;
export const GET_ALL_ACTIVE_NOTIFICATION_TEMPLATES = `${NOTIFICATIONTEMPLATE}Active`;
export const SAVE_NEW_NOTIFICATION = `${NOTIFICATIONTEMPLATE}PostNotificationTemplate`;
export const GET_ALL_TOKENS = `${NOTIFICATIONTEMPLATE}TokensByType`;

//Notification
export const GET_NOTIFICATION_OPTIONS = `${NOTIFICATION}GetNotifications`;
export const SAVE_NOTIFICATION_BY_TEMPLATE = `${NOTIFICATION}SaveNotificationByTemplate`;
export const GET_NOTIFICATION_REPORT_INFO = `${NOTIFICATION}GetNotificationReportInfo`;
export const GET_NOTIFICATIONS_FOR_REPORT = `${NOTIFICATION}GetNotificationsForReport`;

// Data Entry
export const GET_DATA_FOR_LOCATION_DATA_ENTRY = `${DATAENTRY}LocationDataEntry`;
export const SAVE_DATA_FOR_LOCATION_DATA_ENTRY = `${DATAENTRY}SaveLocationDataEntry`;

// Crash
export const GET_TRANSCRIBER_AND_KEYWORDS_DATA = `${CRASH}GetTranscriberAndKeywordsData`;
export const SAVE_KEYWORDS_TO_ONBASE = `${CRASH}SaveKeywords`;

// Checkers - Route Keywords to DMV
export const ROUTE_TO_DMV = `${CRASH}UpdateRouteToDmvFlag`;
export const SET_ROUTE_TO_DMV_FLAG = `${CRASH}UpdateRouteToDmvFlag`;
export const UPDATE_KEYWORDS_FROM_CHECKERS = `${CRASH}UpdateKeywordsFromCheckers`;

//DMV Lookup URLs
export const VIN_VALIDATION_URL = `DmvRequests/ValidateVIN`;
export const LICENSE_PLATE_VALIDATION_URL = `DmvRequests/ValidatePlate`;

// Dmv Search
export const DMV_SEARCH = `${CRASH}DmvSearch`;
export const VALIDATE_VIN = `${CRASH}ValidateVin`;

// Drivers License Validation
export const DRIVERS_LICENSE_LOOKUP = `${DMV}ValidateDln`;

// DuplicateSearch
export const DUPLICATE_SEARCH = `${CRASH}DuplicateSearch`;
export const MERGE_REPORTS = `${MERGE}AutoMergeReports`;

// Flashlight Search
export const SIMPLE_SEARCH = `${CRASH}ReportSearch`;

// Document retrieval
export const GET_ONBASE_IMAGE = `${CRASH}GetOnBaseImage`;
export const GET_LOCAL_IMAGE = `${CRASH}GetLocalImage`;
export const GET_PAPER_IMAGE = `${CRASH}GetPaperImage`;
export const GET_REPORT_IMAGE_BY_REPORT_ID = `${CRASH}GetReportImageById`;
export const GET_FRONTSHEET = `FrontSheet/FrontSheetData`;
export const GENERATE_FRONT_SHEET = `FrontSheet/Generate`;
export const GENERATE_PDF = `print/GeneratePdf`;
export const FORM_40 = `${CRASH}GenerateInvestigatorForm`;

// Mapping
export const UPDATE_SPOT_MAPPED_LOCATION = `${MAPPING}UpdateSpotMap`;
export const GET_NEAREST_INTERSECTIONS = `${MAPPING}GetIntersectionRelatedData`;
export const GET_RELATED_ROADWAY_DATA = `${MAPPING}GetRelatedRoadNameData`;
export const GET_CITY_BY_LAT_LONG = `${MAPPING}GetCityByLatLong`;

// Data Transcriber
export const GET_REPORT_VALIDATION_JSON_FOR_LOCATION = `${DATATRANSCRIBER}ReportValidationJsonForLocationQueue`;
export const GET_REPORT_VALIDATION_JSON = `${DATATRANSCRIBER}ReportValidationJson`;
export const GET_REPORT_VALIDATION_JSON_BY_REPORT_ID = `${DATATRANSCRIBER}ReportValidationJsonByReportId`;
export const GET_REPORT_JSON = `${DATATRANSCRIBER}ReportJson`;

// Keywords
export const COMPLETE_PAPER_KEYWORDS = `${KEYWORDS}CompletePaperKeyword`;
// Keywords - State Property Damage
export const SAVE_STATE_PROPERTY_DAMAGE = `${KEYWORDS}UpdateSpdFlag`;
// Keywords - Work Zone
export const SAVE_WORK_ZONE_INDICATOR = `${KEYWORDS}UpdateWorkZoneIndicator`;
export const SET_REPORT_GROUPING_KEY = `${WORKFLOW}SetReportsGroupingKey`;
export const REMOVE_REPORTS_GROUPING_KEY = `${WORKFLOW}RemoveReportsGroupingKey`;
export const REMOVE_FROM_MANAGEMENT_QUEUE = `${WORKFLOW}RemoveFromManagementQueue`;

//WorkZone Search
export const WORK_ZONE_SEARCH = `${CRASH}WorkZoneSearch`;
export const WORK_ZONE_REMOVED_REPORTS_SEARCH = `${CRASH}WorkZoneRemovedReportsSearch`;
export const REMOVE_REPORT_FROM_WORK_ZONE_SEARCH = `${CRASH}RemoveReportFromWorkZoneSearch`;
export const ADD_REPORT_TO_WORK_ZONE_SEARCH = `${CRASH}AddReportToWorkZoneSearch`;
export const NDOT_WORK_ZONE_INDICATOR_UPDATE = `${CRASH}UpdateNdotWorkZoneIndicator`;
export const NDOT_WORK_ZONE_DISAPPROVE = `${CRASH}NdotWorkZoneDisapprove`;

// Extracts
export const EXTRACTS_SEARCH = `${EXTRACT}ExtractSearch`;
export const REGENERATE_EXTRACT = `${EXTRACT}RegenerateExtract`;
export const RESEND_EXTRACT = `${EXTRACT}ResendExtract`;
export const GET_EXTRACT_TYPES = `${EXTRACT}GetExtractTypes`;
export const GENERATE_AND_SEND_EXTRACT = `${EXTRACT}GenerateExtract`;
export const GET_EXTRACT = `${EXTRACT}GetExtract`;

// Standard Summary
export const STANDARD_SUMMARY_SEARCH = `${STANDARD_SUMMARY}StandardSummarySearch`;
export const REGENERATE_STANDARD_SUMMARY = `${STANDARD_SUMMARY}RegenerateExtract`;
export const RESEND_STANDARD_SUMMARY = `${STANDARD_SUMMARY}ResendExtract`;
export const GET_STANDARD_SUMMARY_TYPES = `${STANDARD_SUMMARY}GetStandardSummaryTypes`;
export const GET_STANDARD_SUMMARY_DATABASES = `${STANDARD_SUMMARY}GetStandardSummaryDatabases`;
export const GENERATE_AND_SEND_STANDARD_SUMMARY = `${STANDARD_SUMMARY}GenerateExtract`;
export const GET_STANDARD_SUMMARY = `${STANDARD_SUMMARY}GetStandardSummary`;
export const GET_STANDARD_SUMMARY_PROGRESS = `${STANDARD_SUMMARY}GetStandardSummaryProgress`;
export const SS_CREATE_PDF = `${STANDARD_SUMMARY}HtmlToPdf`;
export const SS_SAVE = `${STANDARD_SUMMARY}SaveStandardSummary`;

// Power BI
export const POWERBI_ADMIN_SEARCH = `${POWERBI}Search`;
export const POWERBI_SAVE_NEW_REPORT = `${POWERBI}SaveNewReport`;
export const POWERBI_EDIT_REPORT = `${POWERBI}EditReport`;
export const POWERBI_SAVE_REPORT_SHARING = `${POWERBI}SaveReportSharing`;
export const POWERBI_DELETE_REPORT = `${POWERBI}DeleteReport`;
export const POWERBI_GET_MY_PINNED_REPORTS = `${POWERBI}GetPinnedReports`;
export const POWERBI_GET_DATASETS = `${POWERBI}GetDatasets`;

// Comments
export const GET_COMMENTS_BY_REPORT_ID = `${COMMENT}GetCommentsByReportId`;
export const SAVE_REPORT_COMMENT = `${COMMENT}SaveComment`;
export const ADD_COMMENT_VIEW = `${COMMENT}AddCommentView`;

// farsReport
export const GET_FATALITY_REPORTS_NOT_REMOVED = `${FARS_REPORT}GetFatalityReportsNotRemoved`;
export const REMOVE_REPORT_FROM_FARS = `${FARS_REPORT}RemoveReportFromFars`;
export const DELETE_FARS_REPORT = `${FARS_REPORT}DeleteFarsReport`;
export const SEND_TO_NHTSA = `${FARS_REPORT}SendToNhtsa`;

// view transcribe validation form
export const GET_REPORT_DRAFT_BY_REPORT_ID = `${REPORT_DRAFTS}GetReportDraftByReportId`;

// easyquery api default
export const EASY_QUERY_DEFAULT_API = 'easyquery';

// Global Search
export const GLOBAL_SEARCH = `${CRASH}GlobalSearch`;
export const GET_REPORT_WITH_KEYWORDS = `${REPORT}GetReportWithKeywords`;

export const SAVE_URLS = [
  SAVE_KEYWORDS,
  'CompletePaperDataTranscribe',
  'SaveDataTranscriberValidation',
  SAVE_DATA_ENTRY,
  SAVE_CHECKERS,
  SAVE_MANAGEMENT_WORK,
  SAVE_MANAGEMENT_SPLIT,
  SAVE_REPORT_COMMENT,
  SAVE_DATA_FOR_LOCATION_DATA_ENTRY,
  SAVE_FORM_DATA_TO_CRASH_TABLES,
  SAVE_KEYWORDS_TO_ONBASE,
  COMPLETE_PAPER_KEYWORDS,
  COMPLETE_DRIVER_REPORT,
  COMPLETE_PAPER_DATA_TRANSCRIBE,
  COMPLETE_PAPER_DATA_TRANSCRIBER_VALIDATION,
  COMPLETE_WORKFLOW_STEP,
  COMPLETE_CHECKERS,
  COMPLETE_DATA_ENTRY,
  DO_AUTO_MERGE,
];

export const UPDATE_KEYWORDS_TO_ONBASE_BY_DOC_IDS = `NdotApi/UpdateKeywordsForDocIds`